import Icon from '@passkeys/ui/icon';
import Skeleton from '@passkeys/ui/skeleton';
import Text from '@passkeys/ui/text';
import TokenIcon from '@passkeys/ui/token-icon';
import type { MouseEventHandler } from 'react';

import type { Asset } from '@/types';

export interface TokenPickerButtonProps {
  selected: Asset;
  disabled?: boolean;
  noText?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  withChainBadge?: boolean;
  dataTestId?: string;
}

function TokenPickerButton({
  selected,
  disabled,
  noText,
  onClick,
  withChainBadge,
  dataTestId,
}: TokenPickerButtonProps) {
  return (
    <button
      className="flex items-center gap-x-2"
      onClick={onClick}
      disabled={disabled}
      type="button"
      data-testid={dataTestId}
    >
      <TokenIcon
        name={selected.name}
        displayName={selected.displayName}
        chainName={selected.baseAssetName}
        withChainBadge={withChainBadge}
        size={32}
      />
      {(!disabled || !noText) && (
        <div className="flex items-center gap-x-0.5">
          {!noText && <Text>{selected.displayTicker}</Text>}
          {!disabled && (
            <Icon
              className="text-gray-400 theme-dark:text-neutral-200"
              name="triangle-down"
              size={24}
            />
          )}
        </div>
      )}
    </button>
  );
}

export function TokenPickerButtonSkeleton({
  noText,
}: Pick<TokenPickerButtonProps, 'noText'>) {
  return (
    <div className="flex items-center gap-x-2">
      <Skeleton width={32} height={32} />

      {!noText && <Skeleton width={32} height={16} className="my-1" />}
    </div>
  );
}

export default TokenPickerButton;
